import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import { FAQSection } from '@/components/home/FAQSection';
import { BuildingBetterSection } from '@/components/home/BuildingBetterSection';
import { LatestProjectsSection } from '@/components/home/LatestProjectsSection';
import { StatsSection } from '@/components/home/StatsSection';
import { ProcessSection } from '@/components/home/ProcessSection';
import { WhyChooseSection } from '@/components/home/WhyChooseSection';

import { SeoHead } from '@/components/seo/SeoHead';

const Index = () => {
  return (
    <Layout backgroundVariant="default">
      <SeoHead
        title="Construction Company in Jaffna | AST Construction"
        description="AST Construction is a trusted construction company in Jaffna delivering residential, commercial, and industrial projects with precision, quality, and safety."
        keywords={[
          'construction company in jaffna',
          'residential construction jaffna',
          'commercial builders jaffna',
        ]}
        path="/"
      />
      <HeroSection />

      <BuildingBetterSection />

      <LatestProjectsSection />

      <StatsSection />

      <WhyChooseSection />

      <ProcessSection />

      <FAQSection />
    </Layout>
  );
};

export default Index;
